import useUpdateUserMeta from './useUpdateUserMeta';

export default useUpdateUserMeta;
